// extracted by mini-css-extract-plugin
export default {"challengeContainer":"challenge_challengeContainer__2rz2r","topSection":"challenge_topSection__vEYFz","track":"challenge_track__8jOEj","car":"challenge_car__VHPiv"};